module.exports = __webpack_public_path__ + "static/media/Add.6cfa1ea9.svg";